<template>
  <component
    :is="tagName"
    :class="className"
    :alt="alt"
    :src="src"
    loading="lazy"
  />
</template>

<script setup lang="ts">
  import { computed } from 'vue';

  interface Props {
    alt: string;
    src: string;
    bg?: string;
    fit?: string;
    aspect?: string | number;
  }

  const props = defineProps<Props>();

  const className = computed<string>(() => (props.bg ? 'lazy-image lazy-image--bg' : 'lazy-image'));
  const tagName = computed<string>(() => (props.bg ? 'div' : 'img'));
  const bg = computed<string | undefined>(() => (props.bg ? `url(${props.bg})` : undefined));
</script>

<style lang="scss" scoped>
  .lazy-image {
    display: block;
    object-fit: v-bind(fit);
    aspect-ratio: v-bind(aspect);

    .lazy-image--bg {
      background-image: v-bind(bg);
      background-size: cover;
      background-repeat: no-repeat;
    }

    &:not(.lazy-image--bg) {
      max-width: 100%;
      max-height: 100%;
    }

    &[data-src] {
      position: relative;

      &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(150.35deg, rgba(0, 0, 0, 0.88) 0%, rgba(43, 55, 67, 0) 37.86%);
      }

      &:before {
        content: '';
        position: absolute;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(344.7deg, rgba(0, 0, 0, 0.8) 0.61%, rgba(0, 0, 0, 0) 51.65%);
      }
    }
  }
</style>
